import { IAppRoutes } from 'src/app/routes/app-routes.js';

export class TypeRoutesModuleConfig {
	constructor(public appRoutes: IAppRoutes) {}
}
